import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTheoryHelp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M894 20Q935 20 957.5 42.5 980 65 980 106L980 724Q980 764 957.5 787 935 810 894 810L448 810 448 92 98 92 98 548 20 548 20 106Q20 65 43 42.5 66 20 106 20ZM522 738L902 738 902 92 522 92ZM602 182L822 182 822 231 602 231ZM602 321L772 321 772 370 602 370ZM602 460L822 460 822 509 602 509ZM772 599L772 648 602 648 602 599ZM219 732L19 746 19 668 328 668 328 980 250 980 263 779 50 996 0 943Z" })
});
export default SvgTheoryHelp;
